<template>
  <GcsaScrollToTop :locale="normalizedLocale" :aria-label="ariaLabel || undefined" />
</template>

<script setup lang="ts">
/**
 * Web Component root for <gcsa-scroll-to-top>
 *   <gcsa-scroll-to-top locale="zh-CN"></gcsa-scroll-to-top>
 */
import { computed } from 'vue';
import GcsaScrollToTop from './GcsaScrollToTop.vue';
import type { SiteFooterLocale } from '../consts/gcsaFooterContent';
import { normalizeSiteFooterLocale } from '../consts/siteLocales';

const props = withDefaults(
  defineProps<{
    locale?: string;
    ariaLabel?: string;
  }>(),
  {
    locale: 'zh-CN',
    ariaLabel: ''
  }
);

const normalizedLocale = computed<SiteFooterLocale>(() =>
  normalizeSiteFooterLocale(props.locale)
);
</script>
